import React from "react";
import styles from "../../assets/scss/v1/WeddingThankYou.module.scss"
import imageLeft1 from "../../assets/images/v1/wedding-card/flowerLeft1.png";
import imageRight2 from "../../assets/images/v1/wedding-card/flowerRight2.png";
import WishesForm from "../v0/WishesForm";

const WeddingThankYou = () => {

    const thankYouMsg = "<b>8 năm</b> – một hành trình dài với biết bao yêu thương, thấu hiểu và cùng nhau trưởng thành. " +
        "Mỗi hành trình vợ chồng con/em/mình đi qua đều có sự yêu thương, che chở của mọi người. " +
        "Vợ chồng con/em/mình xin được gửi lời cảm ơn chân thành nhất đến bố mẹ 2 bên, anh chị em, họ hàng, bạn bè và đồng nghiệp đã luôn bên cạnh, đồng hành và sẻ chia. " +
        "Sự hiện diện của mọi người trong ngày trọng đại này chính là món quà ý nghĩa nhất mà chúng con/em/mình có được. <br/> " +
        "Người bên mình năm 17 tuổi, cuối cùng cũng có thể đi cùng mình đến hết cuộc đời này rồi ạ!";

    return (
        <>
            <div className={styles.weddingThankYou}>
                <img className={`${styles.imageLeft1} ${styles.imageLeft}`} src={imageLeft1} alt={"imageLeft1"}/>
                <img className={`${styles.imageLeft2} ${styles.imageLeft}`} src={imageRight2} alt={"imageLeft1"}/>
                <img className={`${styles.imageRight1} ${styles.imageRight}`} src={imageLeft1} alt={"imageLeft1"}/>
                <div className={styles.weddingThankYouContainer}>
                    <div className={styles.titleSection}>
                        <div className={styles.title}>Thank you</div>
                        <div className={styles.subTitle}>
                            <span dangerouslySetInnerHTML={{__html: thankYouMsg}}></span>
                        </div>
                    </div>
                    <div className={styles.container}>
                        <WishesForm/>
                    </div>
                </div>

            </div>
        </>
    )
}

export default WeddingThankYou;



